import { CodeValue } from "./CodeValue";
import { MedicationBatchModel } from "./MedicalBatchModel";

class MedicationModel {
    public Id: string;
    public Agent: CodeValue;
    public TradeName: string;
    public ManufacturerCode: string;
    public Batches: MedicationBatchModel[];

    public constructor(init?: Partial<MedicationModel>) {
        Object.assign(this, init);
    }

    public static getDisplayName(model: MedicationModel): string {
        return `${model.TradeName} (${model.Agent.Label})`;
    }
}

export { MedicationModel };
